export const DATA_USER_EMAIL_DOMAIN = "@playwrighttest.com";
export const DATA_USER_FIRST_NAME = "Playwright";
export const DATA_USER_LAST_NAME = "Test";
export const DATA_USER_NAME = `${DATA_USER_FIRST_NAME} ${DATA_USER_LAST_NAME}`;
export const DATA_USER_PASSWORD = "playwrighttest";
